var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<span class="card-heading">Operation parameters (JSON):</span>\n<textarea class="parameters js-parameters"></textarea>\n<p><button class="btn js-run">Run</button></p>';
}
return __p;
};
